export enum QuoteType {
  Project = 'Project',
  HollowMetal = 'Hollow Metal',
  ADSystems = 'AD systems',
  StrategicGrowth = 'Strategic Growth'
}
